<template>
	<BaseCard :alt="alt" v-hover="{ active: 'scale-95' }" class="overflow-hidden">
		<CaseInner
			class="relative px-3 pt-3 pb-5"
			:uuid="uuid"
			:modelUuid="modelUuid"
			:name="name"
			:price="price"
			:disabled="locked"
			:centered="centered"
			@click="clickInner()"
		>
			<RiskBar :value="risk" class="w-full" v-if="risk" />
			<div
				class="text-label-secondary absolute top-14 right-1.5 left-1.5 z-2 flex h-10 items-center justify-center gap-2 bg-linear-(--locked-gradient) text-sm font-medium uppercase"
				v-if="locked"
			>
				<LockIcon />
				<div>{{ lockedText ? lockedText : t('locked') }}</div>
			</div>
		</CaseInner>
		<slot />
	</BaseCard>
</template>
<script setup lang="ts">
import BaseCard from './BaseCard.vue'
import RiskBar from './RiskBar.vue'
import CaseInner from './CaseInner.vue'
import LockIcon from '@/assets/icons/lock.svg'
import { useI18n } from 'vue-i18n'

const { t } = useI18n({
	messages: {
		en: {
			locked: 'Locked'
		},
		ru: {
			locked: 'Недоступен'
		}
	}
})

defineProps<{
	alt?: boolean
	risk?: number
	name: string
	uuid: string
	modelUuid?: string
	price?: number
	locked?: boolean
	lockedText?: string
	centered?: boolean
}>()

const emit = defineEmits<{
	(e: 'clickInner'): void
}>()

const clickInner = () => {
	emit('clickInner')
}
</script>
